
<!--  v-if is in case the object model async fetch hasn't been received yet-->
<loading :loading="!Boolean(handler.objectModel)">
  <template #loading>
    <collapsible-section
      :control-name="dropdownControlId"
      :id="dropdownControlId"
      :is-open="false"
      disabled
      class="collapse-item"
    >
      <template #section-header>
        <xpinner />
      </template>
    </collapsible-section>
  </template>
  <template #loaded>
    <collapsible-section
        class="collapse-item"
        :id="`objectModelDataCollapse-${handler.objectModel.client_id}-${dropdownControlId}`"
        control-name="objectModelDataCollapse"
        :disabled="handler.isSingleOnly && handler.isDisabled(handler.objectModel, computedChildTreeContext)"
        :is-open="isOpen(handler.hasObjectModelDataMatch(lowerQ, handler.objectModel))"
    >
      <template #section-header>
        <row>
          <prefix>
            <icon :glyph="varIOClass(handler.variable)"/>
          </prefix>
          <column>
            {{ handler.rootHeader }}
          </column>
        </row>
      </template>
      <template #section-contents>
        <section-fields
          v-if="handler.usersOnly"
          :q="q"
          :handler="handler"
          :section="userSection"
          icon-glyph="member"
          @select="select"
          :select-additional-parameters="[path]"
        />

        <template v-if="!handler.usersOnly">
          <object-model-property-data
            :handler="handler"
            :q="q"
            :object-model="handler.objectModel"
            :level="1"
            :path="path"
            default-open
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          ></object-model-property-data>
          <object-model-user-data
            v-if="!handler.hideRecordHolderData"
            :handler="handler"
            :q="q"
            :object-model="handler.objectModel"
            :level="1"
            :path="path"
            default-open
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          ></object-model-user-data>

          <object-model-linked-submissions-data
            v-if="handler.allowLinkSubmissions"
            :handler="handler"
            :q="q"
            :object-model="handler.objectModel"
            :path="path"
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          ></object-model-linked-submissions-data>

          <object-model-record-metadata-data
            v-if="handler.showRecordMetaData"
            :handler="handler"
            :q="q"
            :object-model="handler.objectModel"
            :level="1"
            :path="path"
            default-open
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          ></object-model-record-metadata-data>
        </template>
        <object-model-relationship-data
            v-if="handler.traverseRelatedObjectModels"
            :handler="handler"
            :q="q"
            :object-model="handler.objectModel"
            :level="1"
            :path="path"
            :parent-tree-context="computedChildTreeContext"
            @select="select"
            :from-model-view="fromModelView"
        ></object-model-relationship-data>
      </template>
    </collapsible-section>
  </template>
</loading>
